<breadcrumb endText="Organization List" [navigations]="breadcrumbNavs" />
<div class="m-5">
  <div class="flex justify-between">
    <div class="font-medium text-xl">
      Organization List
    </div>
    <clear-button (click)="orgConfig()" [faIcon]="faPlus" text="Create new Organization" />
  </div>
  <hr />
  @for (item of items; track item; let i = $index) {
    <div [ngClass]="i % 2 === 0? 'flex justify-between mt-2 p-2 rounded-[8px]': 'flex justify-between mt-2 p-2 rounded-[8px] bg-gray-100'">
      {{item.name}}
      <div class="mr-3">
        <dropdown-menu [menuItems]="item.items" aria-label="Organization Menu"/>
      </div>
    </div>
  }
  <per-page-pagination
    [(currentPagination)]="currentPagination"
    perPageText="Organizations"
    (perPageFunction)="handleServiceCall()"
    (decrementPageFunction)="handleServiceCall()"
    (incrementPageFunction)="handleServiceCall()"
    />
  </div>
